import React from 'react'
import { toast } from 'mdbreact'

export function notify(type, msg) {
    const config = {
        closeButton: false,
        position: 'top-center'
    }

    const formatText = (messages) => {
        return messages.split('\n').map((message, idx) => (
            idx === 0
                ? <div className="font-weight-bold">{message}</div>
                : <div>{message}</div>
        ))
    }

    switch (type) {
        case 'success':
            toast.success(() => <div className="d-flex flex-row">
                <div className="w-20"><i className="dx-icon-check mr-2" /></div>
                <div className="w-80">{formatText(msg)}</div>
            </div>, config)
            break
        case 'warn':
            toast.warn(() => <div className="d-flex flex-row">
                <div className="w-20"><i className="fas fa-exclamation-circle mr-2" /></div>
                <div className="w-80">{formatText(msg)}</div>
            </div>, config)
            break
        case 'error':
            toast.error(() => <div className="d-flex flex-row">
                <div className="w-20"><i className="fas fa-exclamation-triangle mr-2" /></div>
                <div className="w-80">{formatText(msg)}</div>
            </div>, config)
            break
        default:
            break
    }
}